 <template>
    <!-- Pianifica test -->
    <b-modal 
      ref="modal"
      :visible=visible
      :hide-footer="footer_hide" 
      :id="'modal-config_lamp'+this._uid"
      :title="$t('line.config_title')" 
      :ok-title="$t('configura_lamp_modal.ok_button')" 
      :cancel-title="$t('configura_lamp_modal.cancel_button')" 
      @ok="handleOk"
      :ok-disabled="disabilitaOk()"
      @change="change"
      aria-describedby="modal-description"
      @shown="inizializzaStato"
    >
      <!-- @hidden="onModalHidden" -->
      <b-container>
        <p id="modal-description" class="sr-only">
            {{ $t('configura_lamp_modal.spiega_modal') }}
        </p>
        <b-row align-h="center">
          <b-col cols="12">
            <b-card
              border-variant="primary"
              header-bg-variant="light"
              header-text-variant="dark"
              class="mb-3"
            >
            <!-- :sub-title="$t('configura_lamp_modal.title')" -->
              <!-- Selezione Activated o Deactivated-->
              <b-form-group :label="$t('configura_lamp_modal.select_status')" label-for="status-options" label-class="font-weight-bold">
                <b-form-radio-group
                  id="status-options"
                  v-model="isActivated"
                  :options="statusOption"
                  name="status"
                  stacked
                  aria-describedby="status-help"
                  role="radiogroup"
                  @input="imponiStato()"
                />
                <small id="status-help" class="form-text text-muted sr-only">
                    {{ $t('configura_lamp_modal.select_status_help') }}
                </small>
              </b-form-group>
              <!-- Seleziona funzione -->
               <b-form-group v-if="isActivated === '1'" :label="$t('configura_lamp_modal.select_function')" label-for="function-select" label-class="font-weight-bold">
                <b-form-radio-group
                  id="function-select"
                  v-model="selectedFunction"
                  :options="functionOptions"
                  name="functions"
                  stacked
                  aria-describedby="function-help"
                  role="radiogroup"
                  @input="imponiFunzione()"
                />
                <small id="function-help" class="form-text text-muted sr-only">
                  {{ $t('configura_lamp_modal.select_function_help') }}
                </small>
              </b-form-group>

              <!-- Seleziona time switch -->
              <b-form-group v-if="selectedFunction === 'time switch'" :label="$t('configura_lamp_modal.select_time_switch')" label-for="timeswitch-selection" label-class="font-weight-bold">
                <b-form-radio-group
                  id="timeswitch-selection"
                  v-model="selectedTimeSwitch"
                  :options="timeswitchOptions"
                  name="time_switch"
                  stacked
                  aria-describedby="time-switch-help"
                  role="radiogroup"
                />
                <small id="function-help" class="form-text text-muted sr-only">
                  {{ $t('configura_lamp_modal.select_timeswitch_help') }}
                </small>
              </b-form-group>
              <!-- Seleziona stairway pushbutton -->
              <b-form-group v-if="selectedFunction === 'stairway pushbutton'" :label="$t('configura_lamp_modal.select_starway_pushbutton')" label-for="starway-pushbutton-selection" label-class="font-weight-bold">
                <multiselect
                  id="starway-pushbutton-selection"
                  v-model="selectedStairwayPushbutton"
                  :options="stairwaypushbuttonOptions"
                  :placeholder= "$t('configura_lamp_modal.select_input')"
                  label="text"
                  track-by="value"
                  :searchable="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :max-height="200">
                </multiselect>  
              </b-form-group>
              <b-form-group v-if="selectedStairwayPushbutton != null" :label="$t('configura_lamp_modal.select_sp_duration')" label-for="stairway-pushbutton-duration" label-class="font-weight-bold">
                <multiselect
                  id="stairway-pushbutton-duration"
                  v-model="stairwaypushbuttonDuration"
                  :options="spdurationOptions"
                  :placeholder= "$t('configura_lamp_modal.select_duration')"
                  label="text"
                  track-by="value"
                  :searchable="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :max-height="200">
                </multiselect>
              </b-form-group>
              <!-- Seleziona switchable -->
              <b-form-group v-if="selectedFunction === 'switchable'" :label="$t('configura_lamp_modal.select_switchable')" label-class="font-weight-bold">
                <!-- seleziona light switch -->
                <b-form-group :label="$t('configura_lamp_modal.select_light_switch')" label-for="lightswitch-selection" label-class="font-weight-bold font-italic">
                  <multiselect
                    id="lightswitch-selection"
                    v-model="selectedLightswitch"
                    :options="lightswitchOptions"
                    :placeholder= "$t('configura_lamp_modal.select_input')"
                    :selectLabel="$t('configura_lamp_modal.press_select')"
                    :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :max-height="200"
                    :multiple="true"
                    :max="4">
                    <template slot="noResult">
                      <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                    </template>
                    <template slot="noOptions">
                      <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                    </template>
                    <!-- personalizziamo le opzioni selezionate (tag) -->
                    <template slot="tag" slot-scope="props">
                        <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                          <span class="custom-tag badge badge-primary mr-1">
                            <span>{{ props.option.text }}</span>
                            <span class="custom-remove" @click="props.remove(props.option)">x</span>
                        </span>
                    </template>
                    <template slot="maxElements">
                        <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                    </template>
                  </multiselect>
                </b-form-group>
                <!-- seleziona sub distribution -->
                <b-form-group :label="$t('configura_lamp_modal.select_sub_distribution')" label-for="subdistribution-selection" label-class="font-weight-bolder font-italic">
                  <multiselect
                    id="subdistribution-selection"
                    v-model="selectedSubdistribution"
                    :options="subdistributionOptions"
                    :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                    :selectLabel="$t('configura_lamp_modal.press_select')"
                    :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :max-height="200"
                    :multiple="true"
                    :max="4">
                    <template slot="noResult">
                      <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                    </template>
                    <template slot="noOptions">
                      <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                    </template>
                    <!-- personalizziamo le opzioni selezionate (tag) -->
                    <template slot="tag" slot-scope="props">
                        <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                          <span class="custom-tag badge badge-primary mr-1">
                            <span>{{ props.option.text }}</span>
                            <span class="custom-remove" @click="props.remove(props.option)">x</span>
                        </span>
                    </template>
                    <template slot="maxElements">
                        <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                    </template>
                  </multiselect>
                </b-form-group>
                <b-form-group :label="$t('configura_lamp_modal.select_dynamic_light')" label-for="dynamiclight-selection" label-class="font-weight-bolder font-italic">
                  <multiselect
                    id="dynamiclight-selection"
                    v-model="selectedDynamiclight"
                    :options="dynamiclightOptions"
                    :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                    :selectLabel="$t('configura_lamp_modal.press_select')"
                    :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :max-height="200"
                    :multiple="true"
                    :max="4">
                    <template slot="noResult">
                      <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                    </template>
                    <template slot="noOptions">
                      <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                    </template>
                    <!-- personalizziamo le opzioni selezionate (tag) -->
                    <template slot="tag" slot-scope="props">
                        <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                          <span class="custom-tag badge badge-primary mr-1">
                            <span>{{ props.option.text }}</span>
                            <span class="custom-remove" @click="props.remove(props.option)">x</span>
                        </span>
                    </template>
                    <template slot="maxElements">
                        <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                    </template>
                  </multiselect>
                </b-form-group>
                <b-form-group :label="$t('configura_lamp_modal.select_manual_reset')" label-for="manualreset-selection" label-class="font-weight-bolder font-italic">
                  <multiselect
                    id="manualreset-selection"
                    v-model="selectedManualreset"
                    :options="manualresetOptions"
                    :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                    :selectLabel="$t('configura_lamp_modal.press_select')"
                    :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :max-height="200"
                    :multiple="true"
                    :max="4">
                    <template slot="noResult">
                      <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                    </template>
                    <template slot="noOptions">
                      <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                    </template>
                    <!-- personalizziamo le opzioni selezionate (tag) -->
                    <template slot="tag" slot-scope="props">
                        <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                          <span class="custom-tag badge badge-primary mr-1">
                            <span>{{ props.option.text }}</span>
                            <span class="custom-remove" @click="props.remove(props.option)">x</span>
                        </span>
                    </template>
                    <template slot="maxElements">
                        <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                    </template>
                  </multiselect>
                </b-form-group>                                                
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </b-container>

      <b-modal
        id="warning-modal"
        ref="warningModal"
        v-model="showWarning"
        :title="$t('warning')"
        ok-only
        :ok-title="$t('configura_lamp_modal.understood')"
        header-bg-variant="warning"
        header-text-variant="dark"
        aria-labelledby="warning-modal-title"
        aria-describedby="warning-modal-desc"
        role="alertdialog"
        hide-header-close
      >
        <div style="font-size:medium">
          {{ $t('configura_lamp_modal.warning_msg')}}
        </div>
      </b-modal>


      <!-- Alert da utilizzare in caso di errore nell'inserimento dati nel form -->
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="danger"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged">
        <p class="typo-label">{{ alertMessage }}</p>
      </b-alert>

    </b-modal>

</template>

<script>
import multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'


export default {
  name: 'LineConfig',
  components: { multiselect },
  model: {
    prop: "visible",
    event: "change"
  },
  props:
  {
    visible: {
      type: Boolean,
      default: false
    },
    sendAction: null,
    currentCent: null, //nella forma sicuro#000123
    currentLine: null,
  },
  emits: ['hide', 'change'], //'hide', 
  data () {
    return {
      footer_hide:false,
      isActivated: null,
      selectedFunction: null,
      selectedTimeSwitch: null,
      selectedStairwayPushbutton: null,
      selectedLightswitch: null,
      selectedSubdistribution: null,
      selectedDynamiclight: null,
      selectedManualreset: null,
      stairwaypushbuttonDuration: null,

      dismissSecs: 5,
      dismissCountDown: 0,
      alertMessage:"",
      spdurationOptions: Array.from({ length: 480 }, (_, i) => ({
        text: `${i + 1} min`,
        value: String(i + 1)
      })),
      showWarning: false
    }
  },

  computed: {
    statusOption() {
      return [
        { text: this.$t('configura_lamp_modal.actived'), value: '1' },
        { text: this.$t('configura_lamp_modal.deactivated'), value: '0' }
      ];
    },
    functionOptions() {
      return [
          { text: this.$t('configura_lamp_modal.maintained'), value: 'mantained' },
          { text: this.$t('configura_lamp_modal.not_maintained'), value: 'not mantained' },
          { text: this.$t('configura_lamp_modal.time_switch'), value: 'time switch' },
          { text: this.$t('configura_lamp_modal.stairway_pushbutton'), value: 'stairway pushbutton' },
          { text: this.$t('configura_lamp_modal.switchable'), value: 'switchable' }
        ];
    },
    timeswitchOptions() {
      return [
        { text: this.$t('configura_lamp_modal.time_switch') + ' 1', value: '1' },
        { text: this.$t('configura_lamp_modal.time_switch') + ' 2', value: '2' },
        { text: this.$t('configura_lamp_modal.time_switch') + ' 3', value: '3' }
      ];
    },
    // ricerca, nella centrale corrente, gli lssa e resttuisce gli input configurati come manual reset
    manualresetOptions() {
      var values = [];
      var Cent = this.$store.state.plantUnits.find(cent => cent.cu_id === this.currentCent.split('#')[1]);
      if (Cent != null) {
        Cent.lssa.forEach(lssa => {
          lssa.inputs.forEach(input => {
            if ((input.program != null) && (input.program.toLowerCase() == 'manual reset')) {
              values.push({
                text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
                value: String(input.address)
              });
            } 
          });
        });
      }
      return values;
    },
    // ricerca, nella centrale corrente, gli lssa e resttuisce gli input configurati come dynamic light
    dynamiclightOptions() {
      var values = [];
      var Cent = this.$store.state.plantUnits.find(cent => cent.cu_id === this.currentCent.split('#')[1]);
      if (Cent != null) {
        Cent.lssa.forEach(lssa => {
          lssa.inputs.forEach(input => {
            if ((input.program != null) && (input.program.toLowerCase() == 'dynamic light')) {
              values.push({
                text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
                value: String(input.address)
              });
            } 
          });
        });
      }
      return values;
    },
    //ricerca, nella centrale corrente, gli lssa e restituisce gli input configurati come sub-distribution
    subdistributionOptions() {
      var values = [];
      var Cent = this.$store.state.plantUnits.find(cent => cent.cu_id === this.currentCent.split('#')[1]);
      if (Cent != null) {
        Cent.lssa.forEach(lssa => {
          lssa.inputs.forEach(input => {
            if ((input.program != null) && (input.program.toLowerCase() == 'sub distribution')) {
              values.push({
                text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
                value: String(input.address)
              });
            }
          });
        });
      }
      return values;
    },
    //ricerca, nella centrale corrente, gli lssa e restituisce gli input configurati come light switch nella forma {text: 'Input x', value: 'x'}
    lightswitchOptions() {
      var values = [];
      var Cent = this.$store.state.plantUnits.find(cent => cent.cu_id === this.currentCent.split('#')[1]);
      if (Cent != null) {
        Cent.lssa.forEach(lssa => {
          lssa.inputs.forEach(input => {
            if ((input.program != null) && (input.program.toLowerCase() == 'light switch')) {
              values.push({
                text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
                value: String(input.address)
              });
            }
          });
        });
      }
      return values;
    },
    //ricerca, nella centrale corrente, gli lssa e restituisce gli input configurati come stairway pushbutton
    stairwaypushbuttonOptions() {
      var values = [];
      var Cent = this.$store.state.plantUnits.find(cent => cent.cu_id === this.currentCent.split('#')[1]);
      if (Cent != null) {
        Cent.lssa.forEach(lssa => {
          lssa.inputs.forEach(input => {
            if ((input.program != null) && (input.program.toLowerCase() == 'stairway pushbutton')) {
              values.push({
                text: this.$t('inputs_cu_modal.address') + ` ${input.address}`,
                value: String(input.address)
              });
            } 
          });
        });
      }
      return values;
    }
  },
  methods: {
    imponiFunzione() {
      if (this.selectedFunction === this.currentLine.line_function.toLowerCase()) {
        this.imponiValoriInMemoria();
      } else {
        this.selectedTimeSwitch = null; 
        this.selectedStairwayPushbutton = null; 
        this.selectedLightswitch = null; 
        this.selectedSubdistribution = null; 
        this.selectedDynamiclight = null; 
        this.selectedManualreset = null;
      }
    },
    //funzione che si attiva al cambiamento dello stato Activated/Deactivated
    //se Activated imposta le variabili in memoria con i valori correnti della linea (currentLine)
    //se Deactivated resetta tutte le variabili in memoria
    imponiStato() {
      console.log("imponiStato, isActivated: ", this.isActivated);
      if (this.isActivated === '1') {
        this.imponiValoriInMemoria();
      } else {
        this.resetVariabili();
      }
    },
    //Il modal viene creato all'inizio di Centrali.vue e poi il contenuto, props comprese, vengono caricate dinamicamente
    //con possibili problemi di rendering. Per questo motivo, ogni volta che il modal viene mostrato, si reimpostano
    //le variabili di stato
    inizializzaStato() {
      this.showWarning = false;
      this.isActivated = this.currentLine.deactivated === 'OFF' ? '1' : '0';
      if (this.isActivated === '1') {
        this.imponiValoriInMemoria();
      } else {
        this.resetVariabili();
      }
    },

    //imposta le variabili usate per la configurazione in base ai valori correnti della linea (recuperati da currentLine)
    imponiValoriInMemoria() {
      //this.selectedFunction = this.functionOptions.find(option => option.value == this.currentLine.line_function.toLowerCase());
      this.selectedFunction = this.currentLine.line_function.toLowerCase();
      switch (this.selectedFunction) {
        case 'mantained':
        case 'not mantained':
          this.selectedTimeSwitch = null;
          this.selectedStairwayPushbutton = null;
          this.selectedLightswitch = null;
          this.selectedSubdistribution = null;
          this.selectedDynamiclight = null;
          this.selectedManualreset = null;
          this.stairwaypushbuttonDuration = null;            
          break;
        case 'time switch':
          this.selectedTimeSwitch = this.timeswitchOptions.find(option => option.value == String(this.currentLine.subProgram.time_switch)).value;
          break;
        case 'stairway pushbutton':
          this.selectedStairwayPushbutton = this.stairwaypushbuttonOptions.find(option => option.value == String(this.currentLine.subProgram.stairway_pushbutton));
          this.stairwaypushbuttonDuration = this.spdurationOptions.find(option => option.value == String(this.currentLine.subProgram.time));
          break;
        case 'switchable':
          // recupera gli input configurati
          this.selectedLightswitch = [];
          this.selectedSubdistribution = [];
          this.selectedDynamiclight = [];
          this.selectedManualreset = [];
          for (let i = 1; i <= 4; i++) {
            if (this.currentLine.subProgram[`light_switch_${i}`]) {
              let lsOption = this.lightswitchOptions.find(option => option.value === String(this.currentLine.subProgram[`light_switch_${i}`]));
              if (lsOption) {
                this.selectedLightswitch.push(lsOption);
              }
            }
            if (this.currentLine.subProgram[`sub_distribution_${i}`]) {
              let sdOption = this.subdistributionOptions.find(option => option.value === String(this.currentLine.subProgram[`sub_distribution_${i}`]));
              if (sdOption) {
                this.selectedSubdistribution.push(sdOption);
              }
            }
            if (this.currentLine.subProgram[`dynamic_light_${i}`]) {
              let dlOption = this.dynamiclightOptions.find(option => option.value === String(this.currentLine.subProgram[`dynamic_light_${i}`]));
              if (dlOption) {
                this.selectedDynamiclight.push(dlOption);
              }
            }
            if (this.currentLine.subProgram[`manual_reset_${i}`]) {
              let mrOption = this.manualresetOptions.find(option => option.value === String(this.currentLine.subProgram[`manual_reset_${i}`]));
              if (mrOption) {
                this.selectedManualreset.push(mrOption);
              }
            }
          }
      }
    },
    //resetta tutte le variabili usate per la configurazione
    resetVariabili() {
      this.selectedFunction = null;
      this.selectedTimeSwitch = null;
      this.selectedStairwayPushbutton = null;
      this.selectedLightswitch = null;
      this.selectedSubdistribution = null;
      this.selectedDynamiclight = null;
      this.selectedManualreset = null;
      this.stairwaypushbuttonDuration = null;
    },
    // Abilita il pulsante OK solo se lo stato è attivo e sono state selezionate le opzioni necessarie
    disabilitaOk() {      
      return this.isActivated === null || 
             (this.isActivated == '1' && 
              (this.selectedFunction === null || 
               (this.selectedFunction === 'time switch' && this.selectedTimeSwitch === null) || 
               (this.selectedFunction === 'stairway pushbutton' && (this.selectedStairwayPushbutton === null || this.stairwaypushbuttonDuration === null)) || 
               (this.selectedFunction === 'switchable' && (this.selectedLightswitch === null && this.selectedSubdistribution === null && this.selectedDynamiclight === null && this.selectedManualreset === null))));
    },
    // Filtra le opzioni per escludere quelle già selezionate in altri gruppi
    filteredOptions(index) {      
      const selectedValues = this.groupSelections.filter((_, i) => i !== index);
      return this.allOptions.filter(option => !selectedValues.includes(option.value));
    },
    //si attiva con l'evento 'change' ed emette verso il padre un evento 'change'
    change(visible)
    {
      console.log("change, visible: ", visible);
      // this.isActivated = null;
      // this.selectedFunction = null;
      // this.selectedTimeSwitch = null;
      this.$emit("change", visible);
    },
    //si attiva con l'evento 'hide' ed emette verso il padre un evento 'hide'
    hide()
    {
      console.log("hide, visible: ", this.visible);
      this.$emit("hide");
    },
    //restituisce EMERGENZA  o ILLUMINAZIONE 
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveParam();
    },
    saveParam() 
    { 
      var params ={};
      //parametri comuni
      params.command = "configLinee";
      params.cu_type = this.currentCent.split('#')[0];
      params.cu_id = this.currentCent.split('#')[1];
      //devo intercettare le linee di un AK ext perché il loro indice si ricava con una formula:
      //((63 - index_AKext) * 4 ) + line_num
      if (this.currentLine.index.includes('ext')) {
        let index_AKext = Number(this.currentLine.ak);
        params.line_index = ((63 - index_AKext) * 4 ) + Number(this.currentLine.line_num);
      } else {
        params.line_index = this.currentLine.index;
      }
      console.log("LineConfig, line_index: ", params.line_index);
      params.function = this.currentLine.line_function.toLowerCase();
      if (this.isActivated === '0') {
        params.deactivated = '1';
        //devo recuperare i valori correnti della linea
        params.function = this.currentLine.line_function.toLowerCase();
        switch (params.function) {
          case 'time switch':
            params.ts = this.currentLine.subProgram.time_switch;
            break;
          case 'stairway pushbutton':
            params.sp = this.currentLine.subProgram.stairway_pushbutton;
            params.duration = this.currentLine.subProgram.time;
            break;
          case 'switchable':
            for (let i = 1; i <= 4; i++) {
              if (this.currentLine.subProgram[`light_switch_${i}`]) {
                params[`ls_${i}`] = this.currentLine.subProgram[`light_switch_${i}`];
              }
              if (this.currentLine.subProgram[`sub_distribution_${i}`]) {
                params[`sd_${i}`] = this.currentLine.subProgram[`sub_distribution_${i}`];
              }
              if (this.currentLine.subProgram[`dynamic_light_${i}`]) {
                params[`dl_${i}`] = this.currentLine.subProgram[`dynamic_light_${i}`];
              }
              if (this.currentLine.subProgram[`manual_reset_${i}`]) {
                params[`mr_${i}`] = this.currentLine.subProgram[`manual_reset_${i}`];
              }
            }
            break;
          case 'mantained':
          case 'not mantained':
          default:
            break;
        }
      } else if (this.isActivated === '1') {
        params.deactivated = '0';
        params.function = this.selectedFunction;
        switch (params.function) {
          case 'time switch':
            params.ts = this.selectedTimeSwitch.value;
            break;
          case 'stairway pushbutton':
            params.sp = this.selectedStairwayPushbutton.value;
            params.duration = this.stairwaypushbuttonDuration.value
            break;
          case 'switchable':
            if (this.selectedLightswitch !== null) {
              for (let i = 0; i < this.selectedLightswitch.length; i++) {
                params[`ls_${i+1}`] = this.selectedLightswitch[i].value;
              }
            }
            if (this.selectedSubdistribution !== null) {
              for (let i = 0; i < this.selectedSubdistribution.length; i++) {
                params[`sd_${i+1}`] = this.selectedSubdistribution[i].value;
              }
            }
            if (this.selectedDynamiclight !== null) {
              for (let i = 0; i < this.selectedDynamiclight.length; i++) {
                params[`dl_${i+1}`] = this.selectedDynamiclight[i].value;
              }
            }
            if (this.selectedManualreset !== null) {
              for (let i = 0; i < this.selectedManualreset.length; i++) {
                params[`mr_${i+1}`] = this.selectedManualreset[i].value;
              }
            }
            break;
          case 'mantained':
          case 'not mantained':
          default:
            break;
        }
      }
      console.log("LineConfig, params: ", params);
      this.sendAction(params);

      // Hide the modal manually
      this.$nextTick(() => {
          this.$refs.modal.hide()
      })     
    },       
  }
}
</script>

<style>

</style>
